<script>
  export let url;
</script>

<div class="wrapper">
  <div class="image">
    <img class="shadow-5" src={url} alt="document" />
  </div>
</div>

<style>
  .wrapper {
    background-color: #e9e9e9;
    text-align: center;
    min-height: 100vh;
  }

  .image {
    padding: 12px;
  }

  img {
    width: 100%;
  }
</style>
